import type { Facility } from '@/models/types/facility/facility'

const defaultDateFormatter = new Intl.DateTimeFormat('it-IT', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Rome' })

const range = (start: number, end: number): number[] => {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

function randomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

function getFullAddressFromFacility(facility: Facility): string {
    let result = ''
    if (facility.address !== undefined) {
        result += facility.address
    }
    if (facility.postalCode !== undefined) {
        result += ` - ${facility.postalCode}`
    }
    if (facility.city !== undefined) {
        result += ` ${facility.city}`
    }
    if (facility.province !== undefined) {
        result += ` (${facility.province})`
    }
    return result
}

const formatDate = (date: string | number | Date): string => {
    if (typeof date === 'string' && date.includes('T') && !date.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(date)) {
        return defaultDateFormatter.format(new Date(date + 'Z'))
    }
    return defaultDateFormatter.format(new Date(date))
}

const convertToLocalTimeString = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }

    return date.toLocaleTimeString('it-IT', options)
}

const convertToItalianNumber = (
    num: number | string,
    options: Intl.NumberFormatOptions = { minimumFractionDigits: 1, maximumFractionDigits: 4, useGrouping: true},
): string => {
    const parsedNumber = typeof num === 'string' ? Number(num) : num
    return parsedNumber.toLocaleString('it-IT', options)
}

const convertToItalianWithDecimals = (
    num: number | string,
    decimals = 4,
): string => {
    const parsedNumber = typeof num === 'string' ? Number(num) : num
    return parsedNumber.toLocaleString('it-IT', { minimumFractionDigits: decimals, maximumFractionDigits: decimals})
}

const convertToInternationalNumber = (num: string): number => {
    const valueAsString = String(num)
    const [integerPart, decimalPart] = valueAsString.split(',')
    const internationalIntegerPart = integerPart.replace('.', '')
    const convertedNumber = decimalPart ? `${internationalIntegerPart}.${decimalPart}` : internationalIntegerPart
    const result = Number(convertedNumber)
    return result
}



export {
    capitalizeFirstLetter,
    convertToInternationalNumber,
    convertToItalianNumber,
    convertToItalianWithDecimals,
    convertToLocalTimeString,
    formatDate,
    getFullAddressFromFacility,
    randomInt,
    range,
}
